import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import Breadcrumbs from '../components/common/Breadcrumbs';
import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';
import { MediaPlayer, MediaProvider } from '@vidstack/react';
import { defaultLayoutIcons, DefaultVideoLayout } from '@vidstack/react/player/layouts/default';

import ShareActions from '../components/common/ShareActions';
import OrgBlock from '../components/common/OrgBlock';
import VideoCard from '../components/common/VideoCard';

const VideoDettaglioPage = () => {
  return (
    <Layout>
      <div className="container">
        <Breadcrumbs items={[{ label: 'Home', path: '/' }, { label: 'Video', path: '/video' }, { label: 'Intervista a Giulia Marchetti' }]} style={{ paddingTop: 'var(--space-6)' }} />
      </div>
      <article className="section section--sm">
        <div className="container">
          <div className="detail-layout">
            <div className="content-narrow">
              <div className="card__meta mb-4">
                <span className="badge badge--primary">Intervista</span>
                <span>5 Mar 2026</span>
                <span className="card__meta-dot"></span>
                <span>28:10 min</span>
              </div>
              <h1 className="h1 mb-6">Intervista a Giulia Marchetti: il futuro dei Giovani Democratici</h1>
              
              {/* Video Player */}
              <div style={{ marginBottom: 'var(--space-8)', borderRadius: 'var(--radius-xl)', overflow: 'hidden', boxShadow: 'var(--shadow-lg)' }}>
                <MediaPlayer title="Intervista a Giulia Marchetti" src="https://files.vidstack.io/sprite-fight/720p.mp4">
                  <MediaProvider />
                  <DefaultVideoLayout icons={defaultLayoutIcons} thumbnails="https://files.vidstack.io/sprite-fight/thumbnails.vtt" />
                </MediaPlayer>
              </div>

              <div className="flex items-center gap-4 mb-8" style={{ paddingBottom: 'var(--space-6)', borderBottom: '1px solid var(--color-border)' }}>
                <div style={{ width: 48, height: 48, borderRadius: 'var(--radius-full)', background: 'var(--color-primary-subtle)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'var(--weight-bold)', color: 'var(--color-primary)' }}>GD</div>
                <div>
                  <div style={{ fontWeight: 'var(--weight-semibold)' }}>Canale Ufficiale GD</div>
                  <div className="text-meta">12k iscritti</div>
                </div>
                <ShareActions label="Condividi" style={{ marginLeft: 'auto' }} />
              </div>

              <div className="prose">
                <p className="text-lead mb-6">Un'intervista approfondita a Giulia Marchetti sulle prossime sfide e le nuove direzioni politiche dell'organizzazione giovanile.</p>
                <p>Durante la puntata di "Spazio Giovani", abbiamo avuto il piacere di ospitare Giulia Marchetti per discutere delle nuove sfide che attendono i Giovani Democratici nei prossimi mesi.</p>
                <h2>I temi affrontati</h2>
                <p>Nel corso dell'intervista sono stati toccati diversi punti cruciali per la nostra generazione:</p>
                <ul>
                  <li><strong>Lavoro e precariato:</strong> le nuove proposte di legge per la tutela dei giovani lavoratori.</li>
                  <li><strong>Transizione ecologica:</strong> come le amministrazioni locali possono fare la differenza.</li>
                  <li><strong>Diritti civili:</strong> le prossime battaglie per una società più equa e inclusiva.</li>
                  <li><strong>Partecipazione giovanile:</strong> l'importanza di riportare i giovani al centro del dibattito politico.</li>
                </ul>
                <blockquote>"Non possiamo essere solo il futuro di questo paese, dobbiamo pretendere di essere il presente, con le nostre idee e le nostre battaglie." — Giulia Marchetti</blockquote>
                <p>Guarda l'intervista completa per scoprire i dettagli delle nostre proposte e come puoi partecipare attivamente sul tuo territorio.</p>
              </div>

              <div className="mt-8 mb-8" style={{ paddingTop: 'var(--space-6)', borderTop: '1px solid var(--color-border)' }}>
                <div className="text-label mb-3">Argomenti</div>
                <div className="tags">
                  {['Intervista', 'Politica', 'Lavoro', 'Diritti'].map((t) => <span className="tag" key={t}>{t}</span>)}
                </div>
              </div>
            </div>

            <aside>
              <OrgBlock title="Video Correlati" className="mb-6">
                <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-6)', marginTop: 'var(--space-4)' }}>
                  <VideoCard 
                    title="Spot &quot;Abitare Giovane&quot; — Il diritto di restare" 
                    duration="5:22" 
                    category="Campagna" 
                    date="10 Mar" 
                    image="https://images.unsplash.com/photo-1492724441997-5dc865305da7?q=80&w=800&auto=format&fit=crop" 
                    link="/video-dettaglio"
                  />
                  <VideoCard 
                    title="Dibattito: lavoro precario e salario minimo" 
                    duration="22:30" 
                    category="Dibattito" 
                    date="10 Feb" 
                    image="https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=800&auto=format&fit=crop" 
                    link="/video-dettaglio"
                  />
                </div>
              </OrgBlock>
              <OrgBlock title="Newsletter">
                <p className="text-body-sm text-secondary mt-2 mb-4">Non perderti i prossimi aggiornamenti video.</p>
                <form><input type="email" className="form-input mb-3" placeholder="La tua email" /><button type="submit" className="btn btn--primary w-full btn--sm">Iscriviti</button></form>
              </OrgBlock>
            </aside>
          </div>
        </div>
      </article>
    </Layout>
  );
};

export default VideoDettaglioPage;
